import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from "prop-types";
import PrepareIndividualAlbum from './prepare_individual_album';
import useScrollRef from "../../../hooks/albums/use_scroll";
import { fetchNextSetOfAlbums, updateAlbumViewState } from "../meta/slices";
import { captionSortAlbumsData, getAlbumThumnailSize, captionSortMinimumLimit, showViewLessButton} from "../meta/selectors";

/* global photoOrg */

const IterateAndGenerateCaptionSortAlbumDom = ({captionSortAlbumsRes}) => {
    try{
        const dispatch = useDispatch();
        const [ref,setRef] = useScrollRef(captionSortAlbumsRes,true);

        const captionSortAlbumsDataRes = useSelector(captionSortAlbumsData)
        const showViewLessState = useSelector(showViewLessButton);
        const albumsListData = captionSortAlbumsRes.collectionListRes;

        //used for rendering purpose
        const eachMonthGrids = [];
        const clusterKey = useRef(null);
        // Ref for the parent div wrapping the list of clusters
        const wrapperRef = useRef(null);
        // to get the index of the cluster
        const clusterMapping = {
            '0-9': 0,
            'A-H': 1,
            'I-P': 2,
            'Q-Z': 3,
            'Z-Q': 0,
            'P-I': 1,
            'H-A': 2,
            '9-0': 3,
        };
        
        const toggleLoadingBar = (displayType) =>{
            document.getElementById("loadingBar").style.display = displayType;
        }

        const handleNextSetOfViewMore = (clusterKey, clusterIndex) => {
            toggleLoadingBar("block");
            const sortOrder = photoOrg.history.historyState.so || "ascending";
            dispatch(fetchNextSetOfAlbums({clusterKey, clusterIndex, sortOrder})).then(() => {
                toggleLoadingBar("none");
            });
        };
    
        useEffect(() => {
            handleNextSetOfViewMore();
        }, [captionSortAlbumsDataRes]);
    
        const handleViewMore = (event, key) => {
            clusterKey.current = key;
            const clusterIndex = clusterMapping[key];
            handleNextSetOfViewMore(key, clusterIndex);
        };
    
        const handleViewLess = (event, key) => {
            if (wrapperRef.current) {
                const clusterElement = document.getElementById("right-well");
                if (clusterElement) {
                    clusterElement.scrollTop=0;
                    const element = document.getElementById(key);
                    const result = Math.abs(element.getBoundingClientRect().top);
                    let adjustScrollHeight = 100;
                    if(photoOrg.browserUtil.isMobileDevice()){
                        adjustScrollHeight = 500;
                    }
                    clusterElement.scrollTop=result + adjustScrollHeight;
                    dispatch(updateAlbumViewState({
                        currentAlphabetKey: key
                    }));
                }
            }
        };

        for (const key in albumsListData) {
            const val = albumsListData[key];
            eachMonthGrids.push(
                <li key={key} id={key} className='asset-group'>
                    <div className="monthbar">
                        <div className="left">
                            <h2>{key}</h2>
                        </div>
                    </div>
                    
                    {
                        (clusterKey.current === key) ? (
                            val.entities.map(item => {
                                var albumModel = item;
                                let foundAlbum = false;
                                if (photoOrg.selectedAlbumId && albumModel.id === photoOrg.selectedAlbumId) {
                                    photoOrg.foundAlbum = true;
                                    foundAlbum = true;
                                }
                                const props = {albumModel: {...albumModel,preparetnlUrl:true},foundRef: foundAlbum,setRef:setRef, accessType: "owned", container_key:key, albumThumnailSize:getAlbumThumnailSize(),inlineIngestionFlow:false}
                                return <PrepareIndividualAlbum rid="PrepareIndividualAlbum" key={albumModel.id} {...props}/> 
                            }) 
                        ) : (
                            val.entities.slice(0, captionSortMinimumLimit).map(item => {
                                var albumModel = item;
                                let foundAlbum = false;
                                if (photoOrg.selectedAlbumId && albumModel.id === photoOrg.selectedAlbumId) {
                                    photoOrg.foundAlbum = true;
                                    foundAlbum = true;
                                }
                                const props = {albumModel: {...albumModel,preparetnlUrl:true},foundRef: foundAlbum,setRef:setRef, accessType: "owned", container_key:key, albumThumnailSize:getAlbumThumnailSize(),inlineIngestionFlow:false}
                                return <PrepareIndividualAlbum rid="PrepareIndividualAlbum" key={albumModel.id} {...props}/>
                            })
                        )
                    }
                    
                    {
                        (clusterKey.current === key && showViewLessState) ? (
                            <div className="previous-set-album" onClick={(event) => {handleViewLess(event, key)}} >
                                <div className="album-vertical-align">
                                <div className="album-previous"></div>
                                {photoOrg.translations.photos["albumManagement"]["view_less_albums"]}
                                </div>
                            </div>
                        ) : (
                            (val.count > captionSortMinimumLimit ) ? (
                                <div className="next-set-album" onClick={(event) => {handleViewMore(event, key)}}>
                                    <div className="album-vertical-align">
                                    <div className="album-next"></div>
                                    {photoOrg.translations.photos["albumManagement"]["view_more_albums"]}
                                    </div>
                                </div> 
                            ) : ""
                        )
                    }
                </li>)
        }
       
        return (
            <>
                {/* Parent div wrapping the li cluster elements, ref assigned here */}
                <div ref={wrapperRef}>
                    {eachMonthGrids}
                </div>
            </>
        )
    }catch(e){
        photoOrg.clientLogger.error({description: "LIBRARY:captionMinCollection:IterateAndGenerateCaptionSortAlbumDom:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e.message, err_stack: e.stack});
    }

}

IterateAndGenerateCaptionSortAlbumDom.propTypes = {
    captionSortAlbumsRes: PropTypes.shape({
        collectionListRes: PropTypes.object,
        initialResponse: PropTypes.object,
        jumpToModuleData: PropTypes.array
    })
};
export default IterateAndGenerateCaptionSortAlbumDom;